import React from 'react';
import { Box } from '../../../../common/components';
import { TableHeaderColumn } from 'react-bootstrap-table';
import DataTable from '../../../../common/components/DataTable/DataTable';
import formatDate from '../../../../helpers/formatDate';

const RemovalsList = () => {
  return (
    <div>
      <Box>
        <DataTable
          source="/removal-events"
          name="removals"
          showTotal
          //  autoFilters={autoFilters}
          //  onRowSelect={this.handleRowClick.bind(this)}
        >
          <TableHeaderColumn dataField="id" isKey hidden />

          <TableHeaderColumn
            dataField="deletion_date"
            dataSort
            width={'150px'}
            dataFormat={formatDate}
          >
            Date Deleted
          </TableHeaderColumn>

          <TableHeaderColumn
            dataField="policy_applications_deleted"
            dataSort
            width={'150px'}
          >
            Policy Applications Deleted
          </TableHeaderColumn>
          <TableHeaderColumn dataField="policies_deleted" dataSort width={'150px'}>
            Policies Deleted
          </TableHeaderColumn>
          <TableHeaderColumn dataField="premiums_deleted" dataSort width={'150px'}>
            Premiums Deleted
          </TableHeaderColumn>
          <TableHeaderColumn dataField="documents_deleted" dataSort width={'150px'}>
            Documents Deleted
          </TableHeaderColumn>
          <TableHeaderColumn dataField="emails_deleted" dataSort width={'150px'}>
            Emails Deleted
          </TableHeaderColumn>
        </DataTable>
      </Box>
    </div>
  );
};
export default RemovalsList;
